import { defineMessages } from "react-intl";

const messages = defineMessages({
  activity: {
    id: "map.layer.heatMap.edit.type.activity",
    defaultMessage: "Activity",
    description: "Activity type selection on Edit Heat Map panel title on the Map page",
  },
  additionalFilters: {
    id: "map.layer.heatMap.edit.additionalFilters",
    defaultMessage: "Additional Filters",
    description: "Heat map Additional Filters selection on Edit Heat Map panel Map page",
  },
  closingDate: {
    id: "map.layer.heatMap.edit.closingDate",
    defaultMessage: "Closing Date",
    description: "Heat map closing date on Edit Heat Map panel Map page",
  },
  dateDone: {
    id: "map.layer.heatMap.edit.dateDone",
    defaultMessage: "Date Done",
    description: "Heat map date done on Edit Heat Map panel Map page",
  },
  deal: {
    id: "map.layer.heatMap.edit.deal",
    defaultMessage: "Deal Amount",
    description: "Deal type selection on Edit Heat Map panel title on the Map page",
  },
  edit: {
    id: "map.layer.heatMap.edit",
    defaultMessage: "Edit Heat Map",
    description: "Edit Heat Map panel title on the Map page",
  },
  type: {
    id: "map.layer.heatMap.edit.type",
    defaultMessage: "Select type of heat map",
    description: "Heat map type selection on Edit Heat Map panel title on the Map page",
  },
  users: {
    id: "map.layer.heatMap.edit.users",
    defaultMessage: "{activityType, select, true {Assignee} other {Owner}}",
    description: "Heat map users selection on Edit Heat Map panel Map page",
  },
});

export default messages;
